import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { votingApi } from "../../helpers/fetcher";
import { dispatchCardAction } from '../../utils/postMessageUtils';
// import { getRadar } from '@futures-platform/connectors/drupal-api';
import {finalTranslations} from '../../localTranslation'

import Slider from "../Slider/Slider";
import {
  RatingWidget,
  IconLink,
  CloseIcon,
  IconName,
  WidgetHeader,
  RatingItems,
  H3RatingTitle
} from "./styles";
import {DataContext} from '../../store/GlobalState'
import { ACTIONS } from '../../store/Actions';

const Rating = ({ 
  gid, 
  rid, 
  pid,
  lang,
  getRadarData,
  groupRadarId,
  isTranslated,
  langForTransState
}) => {
  const ratingTitleRef = useRef()
  const ratingClearRef = useRef()
  const ratingTitleRef2 = useRef()
  const ratingClearRef2 = useRef()


  const [translations, settranslations] = useState(null)
  const [ratingTitle, setratingTitle] = useState(null)
  const [ratingClear, setratingClear] = useState(null)

  const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateStore, getTheWholeCardHtmlElms, contentData }, dispatch } = useContext(DataContext)
  const groupRadarIdGlobalState = useMemo(() => {
    return groupRadarIdGlobalStateStore ?? groupRadarId
  }, [groupRadarIdGlobalStateStore, groupRadarId])
  const [isSliding, setIsSliding] = useState(false);
  const [sliderXVal, setSliderXVal] = useState(50);
  const [sliderYVal, setSliderYVal] = useState(50);
  const [error, setError] = useState(null);
  const [mouseState, setMouseState] = useState(null);
  const [isFlip, setIsFlip] = React.useState(false)

  const isEmpty = (obj) => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  };

  const onClickSetMouseState = (state) => {
    if (state === "up") {
      setMouseState("up");
    } else {
      setMouseState("down");
    }
  };

  const onChangeXValue = async (e) => {
    setIsSliding(true);
    setSliderXVal(e.target.value);
  };

  const onChangeYValue = async (e) => {
    setIsSliding(true);
    setSliderYVal(e.target.value);
  };

  const clearRatings = async () => {
    setIsSliding(false);
    setSliderXVal(50);
    setSliderYVal(50);
    setError(null)
    await votingApi.clearRatingsCurrentUser(groupRadarIdGlobalState || gid, rid, pid);
    dispatchCardAction('rating_clear', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid });
  };
  const [axisXMax, setaxisXMax] = useState('')
  const [axisXMin, setaxisXMin] = useState('')
  const [axisXTitle, setaxisXTitle] = useState('')
  const [axisYMax, setaxisYMax] = useState('')
  const [axisYMin, setaxisYMin] = useState('')
  const [axisYTitle, setaxisYTitle] = useState('')

  // const fetchRatingCurrentUser = async () => {
    
  //   try {
  //     const  {data}  = await votingApi.getRatingsCurrentUser(gid, rid, pid)
  //     if (!isEmpty(data)) {
  //       const  avgX = data[`/${gid}/radar/${rid}/phenomenon/${pid}/x`].percentage
  //       const avgY = data[`/${gid}/radar/${rid}/phenomenon/${pid}/y`].percentage
  //       setSliderXVal(Number(avgX))
  //       setSliderYVal(Number(avgY))
  //       setIsSliding(true)
  //       setError(null)
  //     }
  //   } catch(e) {
  //     setError(e)
  //   }
  // }

  const addRating = async() => {
    try {
      if (!isFlip) {
        await Promise.all([
          votingApi.addRatingCurrentUser(groupRadarIdGlobalState || gid, rid, pid, 'x', { percentage: sliderXVal }),
          votingApi.addRatingCurrentUser(groupRadarIdGlobalState || gid, rid, pid, 'y', { percentage: sliderYVal })
        ])
        dispatchCardAction('rating', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, x: sliderXVal, y: sliderYVal })
      } else {
        await Promise.all([
          votingApi.addRatingCurrentUser(groupRadarIdGlobalState || gid, rid, pid, 'x', { percentage: sliderYVal }),
          votingApi.addRatingCurrentUser(groupRadarIdGlobalState || gid, rid, pid, 'y', { percentage: sliderXVal })
        ])
        dispatchCardAction('rating', { gid: groupRadarIdGlobalState || gid, radarId: rid, phenomenonId: pid, x: sliderYVal, y: sliderXVal })
      }
      
    } catch(e) {
      setError(e)
    }
  }

  useEffect(() => {
    if (mouseState === 'up') {
      addRating();
    }
  }, [mouseState])


  useEffect(() => {
    (async () => {
      const isFlipAxis = await votingApi.getFlipAxisAfterSaved(groupRadarIdGlobalState || gid, rid)
      setIsFlip(isFlipAxis.data?.isFlip)
      const {data: ratings} = await votingApi.getRatingsCurrentUser(groupRadarIdGlobalState || gid, rid, pid)

      if (!isEmpty(ratings)) {
        if (!isFlipAxis.data?.isFlip) {
          const avgX = ratings[`/${groupRadarIdGlobalState || gid}/radar/${rid}/phenomenon/${pid}/x`].percentage
          const avgY = ratings[`/${groupRadarIdGlobalState || gid}/radar/${rid}/phenomenon/${pid}/y`].percentage
          setSliderXVal(Number(avgX))
          setSliderYVal(Number(avgY))
          setIsSliding(true)
          setError(null)
        } else {
          const avgX = ratings[`/${groupRadarIdGlobalState || gid}/radar/${rid}/phenomenon/${pid}/y`].percentage
          const avgY = ratings[`/${groupRadarIdGlobalState || gid}/radar/${rid}/phenomenon/${pid}/x`].percentage
          setSliderXVal(Number(avgX))
          setSliderYVal(Number(avgY))
          setIsSliding(true)
          setError(null)
        }
        // const avgX = ratings[`/${gid}/radar/${rid}/phenomenon/${pid}/x`].percentage
        // const avgY = ratings[`/${gid}/radar/${rid}/phenomenon/${pid}/y`].percentage
        // setSliderXVal(Number(avgX))
        // setSliderYVal(Number(avgY))
        // setIsSliding(true)
        // setError(null)
      }

      if (!!getRadarData) {
        const {
          axisXMax,
          axisXMin,
          axisXTitle,
          axisYMax,
          axisYMin,
          axisYTitle,
        } = getRadarData
        setaxisXMax(axisXMax)
        setaxisXMin(axisXMin)
        setaxisXTitle(axisXTitle)
        setaxisYMax(axisYMax)
        setaxisYMin(axisYMin)
        setaxisYTitle(axisYTitle)
      }
    })()
  }, [getRadarData])



  useEffect(() => {
    const fetcher = async () => {
      const [res1, res2] = await Promise.all ([
          votingApi.translation("en", langForTransState, ratingTitle ?? ratingTitleRef2.current),
          votingApi.translation("en", langForTransState, ratingClear ?? ratingClearRef2.current)
      ])
      settranslations(() => {
        return {
          res1, res2
        }
      })
    };
    !!isTranslated && !! ratingTitle && !!ratingClear && fetcher();
    
  }, [isTranslated, ratingTitle, ratingClear, langForTransState])

  useEffect(() => {
    if (!!getRadarData) {
      if (true) {
        if (!!ratingTitleRef.current?.innerHTML) {
          ratingTitleRef2.current = ratingTitleRef.current?.innerHTML
        }
        if (!!ratingClearRef.current?.innerHTML) {
          ratingClearRef2.current = ratingClearRef.current?.innerHTML
        }
        !!ratingTitleRef2.current && !ratingTitle && setratingTitle(() => ratingTitleRef2.current)
        !!ratingClearRef2.current && !ratingClear && setratingClear(() => ratingClearRef2.current)
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD7,
        //   payload: true
        // })
      }
    }
  }, [dispatch, isTranslated, getRadarData, ratingTitle, ratingClear])

  return (
    <>
      <RatingWidget>
        <WidgetHeader>
          {
            !isTranslated && (
              <H3RatingTitle ref={ratingTitleRef}  className="mb_5">{lang === 'fi' ? finalTranslations?.rating?.fi : finalTranslations?.rating?.en}</H3RatingTitle>
            )
          }
          {
            !!isTranslated && (
              <H3RatingTitle ref={ratingTitleRef}  className="mb_5" dangerouslySetInnerHTML={{__html: translations?.res1?.data}}></H3RatingTitle>
            )
          }
          <IconLink>
            <CloseIcon></CloseIcon>
            {
              !isTranslated && (
                <IconName ref={ratingClearRef} onClick={clearRatings}>{lang === 'fi' ? finalTranslations?.clearRatings?.fi : finalTranslations?.clearRatings?.en}</IconName>
              )
            }
            {
              !!isTranslated && (
                <IconName ref={ratingClearRef} onClick={clearRatings} dangerouslySetInnerHTML={{__html: translations?.res2?.data}}></IconName>
              )
            }
          </IconLink>
        </WidgetHeader>
        <RatingItems>
          <Slider
            data-title={contentData?.title}
            data-action-id="rating"
            data-rating-value-x={sliderXVal}
            data-rating-min-x={axisXMin}
            data-rating-max-x={axisXMax}
            data-rating-axis-name-x={axisXTitle}
            langForTransState={langForTransState}
            isTranslated={isTranslated}
            isSliding={isSliding}
            axisName={axisXTitle}
            leftValue={axisXMin}
            rightValue={axisXMax}
            sliderVal={sliderXVal}
            onChangeValue={onChangeXValue}
            onClickSetMouseState={onClickSetMouseState}
          />
          <Slider
            data-title={contentData?.title}
            data-action-id="rating"
            data-rating-value-y={sliderYVal}
            data-rating-min-y={axisYMin}
            data-rating-max-y={axisYMax}
            data-rating-axis-name-y={axisYTitle}
            langForTransState={langForTransState}
            isTranslated={isTranslated}
            isSliding={isSliding}
            axisName={axisYTitle}
            leftValue={axisYMin}
            rightValue={axisYMax}
            sliderVal={sliderYVal}
            onChangeValue={onChangeYValue}
            onClickSetMouseState={onClickSetMouseState}
          />
        </RatingItems>
      </RatingWidget>
    </>
  );
};

export default Rating;
